import { kindLabel } from './util';
import type { SyntaxFixRowProps } from './types';

// A single editable rename row: accept/reject checkbox, the original name struck
// through, and an editable target the reviewer can override.
export const SyntaxFixRow = ({ row, checked, target, onToggle, onEditTarget }: SyntaxFixRowProps) => (
  <label className="syntax-row">
    <input type="checkbox" checked={checked} onChange={() => onToggle(row.key)} />
    <div className="syntax-row-main">
      <div className="syntax-row-names">
        <span className="syntax-original">{row.original}</span>
        <span className="syntax-arrow">→</span>
        <input
          className="syntax-target-input"
          value={target}
          onChange={(event) => onEditTarget(row.key, event.target.value)}
        />
      </div>
      {row.reason && <div className="syntax-reason">{row.reason}</div>}
    </div>
    <span className="syntax-kind">{kindLabel(row.kind)}</span>
  </label>
);
